import { render, staticRenderFns } from "./PremioRet.vue?vue&type=template&id=327f2b46"
import script from "./PremioRet.vue?vue&type=script&lang=js"
export * from "./PremioRet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports